import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Star } from 'lucide-react';
import { HeroScene } from './HeroScene';

const Hero: React.FC = () => {
  return (
    <header id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <HeroScene />

      <div className="absolute inset-0 z-0 pointer-events-none bg-[radial-gradient(circle_at_center,rgba(249,248,244,0.92)_0%,rgba(249,248,244,0.6)_50%,rgba(249,248,244,0.3)_100%)]" />

      <div className="relative z-10 container mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="inline-block mb-6 px-4 py-2 border border-serchon-gold text-serchon-gold text-sm tracking-[0.2em] uppercase font-bold rounded-full backdrop-blur-sm bg-white/30"
        >
          <Star size={16} className="inline mr-2" />
          科技创新 · 智领未来
        </motion.div>

        <motion.h1
          className="font-serif text-5xl md:text-7xl lg:text-8xl font-medium leading-tight md:leading-[0.9] mb-6 text-stone-900 drop-shadow-sm"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          溯玄科技
          <br />
          <span className="italic font-normal text-stone-600 text-3xl md:text-5xl block mt-4">Serchon Technology</span>
        </motion.h1>

        <motion.p
          className="max-w-2xl mx-auto text-lg md:text-xl text-stone-700 font-light leading-relaxed mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          专注于人工智能应用软件开发、数据处理服务、软件外包服务等领域，
          <br />
          为企业提供卓越的技术解决方案
        </motion.p>

        <motion.div
          className="flex flex-col items-center gap-2 text-sm font-medium text-stone-500 hover:text-stone-900 transition-colors cursor-pointer animate-bounce"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          onClick={() => {
            const element = document.getElementById('about');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        >
          <span>了解更多</span>
          <span className="p-2 border border-stone-300 rounded-full hover:border-stone-900 transition-colors bg-white/50">
            <ArrowDown size={16} />
          </span>
        </motion.div>
      </div>
    </header>
  );
};

export default Hero;
